export default "__VITE_ASSET__DEIGn8XI__";